import SortingTakeover from './SortingTakeover';
import { connect } from 'react-redux';
import { getSearchParameters } from '../../../../state';
import { trackFilterClickSortMatches } from '../../../../actions';

const mapStateToProps = state => {
    const { sortType } = getSearchParameters(state);

    return {
        sortTypeSelected: sortType,
    };
};

const mapDispatchToProps = {
    onApplySort: trackFilterClickSortMatches,
};

export default connect(mapStateToProps, mapDispatchToProps)(SortingTakeover);
